import { SET_SITES } from '../actions/sites';

export const sitesReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_SITES:
      return {
        ...state,
        sites: payload,
      };
    default:
      return undefined;
  }
};
